import { useCollection } from "../hooks/useCollection"

export const OnlineUsers = () => {
    const { isPending, error, documents } = useCollection('users')
    return (
        <div className="user-list px-3">
          <h2 className="text-sm font-bold text-white" >All USERS</h2>
          {isPending && <div>Loading users...</div>}
          {error && <div>{error}</div>}
          {documents && documents.map(user => (

            <div key={user.id} className="flex item-center user-list-item py-2 ">
               
                  <div className="relative rounded-full w-8 h-8 flex items-center justify-between bg-gray-200">
                  <img className="rounded-full w-8 h-8 " src={user.photoURL} alt="Profile Image" />
                  {!user.online && <div className="absolute right-0 -bottom-1 w-3 h-3 bg-gray-400 rounded-full border-2 border-gray-800"></div>}
                  {user.online && <div className="absolute right-0 -bottom-1 w-3 h-3 bg-green-400 rounded-full border-2 border-gray-800"></div>}
                </div>
            
              <div className="flex justify-center items-center ml-3 ">{user.displayName} </div>
            </div>
          ))}
        </div>
      )
}
